var Passenger = Backbone.View.extend({
  events: {
    "change [data-traveler-type]": "passengerTypeUpdate",
    "change [data-booked-traveler-remove]": "toggleBookedTravelerInfo"
  },

  toggleBookedTravelerInfo: function() {
    if (this.$("[data-booked-traveler-remove]").is(":checked")) {
      this.$("[data-traveler-content]").addClass("is-hidden");
      this.$("[data-traveler-content]")
        .find("input, select, textarea")
        .attr("disabled", true);
    } else {
      this.$("[data-traveler-content]").removeClass("is-hidden");
      this.$("[data-traveler-content]")
        .find("input, select, textarea")
        .removeAttr("disabled", true);
      this.passengerTypeUpdate();
    }
  },

  /**
   * This method updates and toggles the necessary inputs based on passenger type and air information
   */
  passengerTypeUpdate: function() {
    var paxType = this.$("[data-traveler-type]").val();

    this.updateAgeRange(paxType);
    this.toggleAge(
      paxType === "CHD" || (this.settings.has_air && paxType !== "INF")
    );
    this.toggleIsSeated(this.settings.has_air && paxType === "INF");
    this.updateBirthdateRange(paxType);
  },

  /**
   * This method toggles the display of age range
   *
   * @param show
   */
  toggleAge: function(show) {
    this.$("[data-traveler-age-container]")[show ? "removeClass" : "addClass"](
      "is-hidden"
    );

    if (!show) {
      this.$("[data-traveler-age]").val(null);
      this.$("[data-traveler-age]").attr("disabled", true);
    } else {
      this.$("[data-traveler-age]").removeAttr("disabled");
    }
  },

  /**
   * This method toggles the display of is seated air checkbox
   *
   * @param show
   */
  toggleIsSeated: function(show) {
    this.$("[data-traveler-air-seated]")[show ? "removeClass" : "addClass"](
      "is-hidden"
    );
  },

  /**
   * This method toggles the display of the airport trigger
   *
   * @param show
   */
  toggleAirportTrigger: function(show) {
    this.$("[data-airport-trigger-container]")[
      show ? "removeClass" : "addClass"
    ]("is-hidden");
  },

  /**
   * This method updates the passenger age ranage based on passenger type.
   *
   * @param paxType
   */
  updateAgeRange: function(paxType) {
    var selectEl = this.$("[data-traveler-age]");
    var min = 0;
    var max = 100;
    var options = "<option></option>";

    switch (paxType) {
      case "SRC":
        min = this.settings.age_ranges.min_age_senior;
        max = this.settings.age_ranges.max_age_senior || 100;
        break;

      case "ADT":
        min = this.settings.age_ranges.min_age_adult;
        max = this.settings.age_ranges.max_age_adult;
        break;

      case "CHD":
        min = this.settings.age_ranges.min_age_child || 0;
        max = this.settings.age_ranges.max_age_child;
        break;
    }

    for (var x = min; x <= max; x++) {
      options += '<option value="' + x + '">' + x + "</option>";
    }

    $(selectEl).html(options);
  },

  /**
   * This method updates the birthdate range
   *
   * @param paxType
   */
  updateBirthdateRange: function(paxType) {
    var start = null;
    var end = null;

    switch (paxType) {
      case "SRC":
        start = this.settings.date_ranges.senior.start;
        end = this.settings.date_ranges.senior.end;
        break;

      case "ADT":
        start = this.settings.date_ranges.adult.start;
        end = this.settings.date_ranges.adult.end;
        break;

      case "CHD":
        start = this.settings.date_ranges.child.start;
        end = this.settings.date_ranges.child.end;
        break;

      case "INF":
        start = this.settings.date_ranges.infant.start;
        end = this.settings.date_ranges.infant.end;
        break;
    }

    if (
      start &&
      end &&
      $(
        '[data-calendar="date-of-birth-calendar-' +
          this.settings.pax_index +
          '"]'
      ).length
    ) {
      var Calendar = this.$(
        '[data-calendar="date-of-birth-calendar-' +
          this.settings.pax_index +
          '"]'
      ).component();

      Calendar.settings.date = null;
      Calendar.settings.date_min = start;
      Calendar.settings.date_max = end;
      Calendar.setState();
      Calendar.render();
    }
  },

  /**
   * This method toggles the required inputs for integrated air
   */
  toggleRequiredAirInputs: function(has_air) {
    this.settings.has_air = has_air;

    var paxType = this.$("[data-traveler-type]").val();

    this.toggleAge(
      paxType === "CHD" || (this.settings.has_air && paxType !== "INF")
    );
    this.toggleIsSeated(this.settings.has_air && paxType === "INF");
    this.toggleAirportTrigger(this.settings.has_air);
  },

  initialize: function() {
    this.settings = this.$el.data("settings");

    this.toggleRequiredAirInputs(this.settings.has_air);
    this.$el.loadComponents();
    this.$el.loadModules();
  }
});

module.exports = Passenger;
